import Sortable from 'sortablejs';
import { precisionRound } from '@/lib/utils';

const sortable = (el, binding) => {
  /* istanbul ignore next */
  new Sortable(el, binding.value || {}); // eslint-disable-line no-new
};

/**
 * Adds commas to number for usage in formatting currency values
 * @param {string} nStr Number string to add commas to
 * @return {string} formatted number string with commas
 */
const addCommas = (nStr) => {
  nStr += '';
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? `.${x[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
};

/**
 * Formats inputted string or number to a valid currency formatted string.
 * Adds commas and the curency marker to the output.
 * @param {number|string} input number to perform currency formatting on
 * @param {string} [currencyMarker='$'] currency symbol used in final output
 * @return {string} formatted, comma separated currency value
 */
const formatCurrency = (input, currencyMarker = '$') => {
  if (typeof input === 'string') input = parseFloat(input);

  const sign = input < 0 ? '-' : '';
  const absoluteValue = Math.abs(input);

  const roundedValue = precisionRound(absoluteValue);
  if (!roundedValue) return '';

  const formattedValue = addCommas(roundedValue);
  return `${sign}${currencyMarker}${formattedValue}`;
};

export { addCommas, formatCurrency, sortable };
